import {
  DestroyRef,
  Directive,
  inject,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { selectHideDiscountLabelByWsp } from '@epicuro-next/state/user-state';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs';

@Directive({
  selector: '[atxCanShowByWsp]',
  exportAs: 'atxCanShowByWsp',
  standalone: false,
})
export class CanShowByWspDirective {
  private readonly store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
  ) {}

  public ngOnInit() {
    this.store
      .pipe(
        select(selectHideDiscountLabelByWsp),
        map((hideDiscountLabelByWsp) => !hideDiscountLabelByWsp),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((canShowDiscountLabelByWsp) => {
        if (canShowDiscountLabelByWsp) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }
}
